import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import TextField from '@material-ui/core/TextField';

const groupInfoStyles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    row: {
        width: '100%',
    },
    textField: {
        width: '50%',
    },

    spaceLeft: {
        paddingLeft: 5,
    },
    spaceRight: {
        paddingRight: 5,
    },
});

let GroupInfoTab = props => {
    const { classes, groupInfo, groupInfoErrors, onChange, mode } = props;
    const disabled = mode === 'details';
    const setupInputRef = input => {
        if (mode === 'new' && input && input.focus) {
            setTimeout(() => input.focus(), 100);
        }
    };
    return (
        <div className={classes.container}>
            <div className={classes.row}>
                <TextField
                    error={Boolean(groupInfoErrors.name)}
                    required
                    disabled={disabled}
                    label="Name"
                    value={groupInfo.name}
                    onChange={event => onChange('name', event.target.value)}
                    className={classNames(
                        classes.textField,
                        classes.spaceRight
                    )}
                    helperText={groupInfoErrors.name}
                    margin="normal"
                    variant="outlined"
                    inputRef={setupInputRef}
                />
            </div>
        </div>
    );
};

export default withStyles(groupInfoStyles)(GroupInfoTab);
